// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1r5u_","loaderOuter":"PageOverlayLoader_loaderOuter__3mPIn"};